import { render, staticRenderFns } from "./ObjectiveSectionLayout.vue?vue&type=template&id=cb86380a&scoped=true&"
import script from "./ObjectiveSectionLayout.vue?vue&type=script&lang=js&"
export * from "./ObjectiveSectionLayout.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveSectionLayout.vue?vue&type=style&index=0&id=cb86380a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb86380a",
  null
  
)

export default component.exports